import apiClient from '../config/api';
import { Client } from '../types';

class ClientService {
  /**
   * Récupérer tous les clients
   */
  async getAll(): Promise<Client[]> {
    const response = await apiClient.get<Client[]>('/api/clients');
    return response.data;
  }

  /**
   * Récupérer un client par son ID
   */
  async getById(id: number): Promise<Client> {
    const response = await apiClient.get<Client>(`/api/clients/${id}`);
    return response.data;
  }

  /**
   * Créer un nouveau client
   */
  async create(data: Omit<Client, 'id' | 'createdAt' | 'updatedAt'>): Promise<Client> {
    const response = await apiClient.post<Client>('/api/clients', data);
    return response.data;
  }

  /**
   * Mettre à jour un client
   */
  async update(id: number, data: Partial<Client>): Promise<Client> {
    const response = await apiClient.put<Client>(`/api/clients/${id}`, data);
    return response.data;
  }

  /**
   * Supprimer un client
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/clients/${id}`);
  }

  /**
   * Rechercher des clients
   */
  async search(query: string): Promise<Client[]> {
    const response = await apiClient.get<Client[]>('/api/clients/search', {
      params: { q: query },
    });
    return response.data;
  }
}

export default new ClientService();
